import {gql} from "apollo-angular";
import {baseResponse} from "src/app/store/base.graphql";

const permissionFields = `
    id
    permissionGroupUniqueId
    permissionGroupName
    permissionGroupIsGlobal
    permissions {
        id
        permissionUniqueId
        permissionName
        permissionCode
    }
`;

export const GET_SYSTEM_PERMISSIONS =gql`
    query GetSystemPermissions($filtering: PermisionFilteringInputObjects!) {
        getSystemPermissions(filtering: $filtering) {
            data{
                ${permissionFields}
            }
            response{
                ${baseResponse}
            }
        }
    }
`;
